const DEFAULT_WINDOW_PARAMS =
  'toolbar=no, menubar=no, width=1040, height=700, top=100, left=100'

export const useExternalWindow = () => {
  let newWindow: Window | null = null

  const prevUrl = ref<Undefinable<string>>(undefined)

  const openWindow = (
    url: string,
    name: string,
    messageHandler: (e: MessageEvent) => void,
    params: string = DEFAULT_WINDOW_PARAMS,
  ) => {
    const handler = (event: MessageEvent) => {
      const { data } = event

      if (data.messageType === 'oAuth') {
        messageHandler(event)
        window.removeEventListener('message', handler)
      }
    }

    window.removeEventListener('message', handler)

    if (!newWindow || newWindow.closed) {
      // окно ещё не существует, либо было закрыто
      newWindow = window.open(url, name, params)!
    } else if (prevUrl.value !== url) {
      // окно было, но пытаются открыть новое с другим урлом
      newWindow = window.open(url, name, params)!
      newWindow.focus()
    } else {
      // окно уже существует
      newWindow!.focus()
    }

    window.addEventListener('message', handler)

    prevUrl.value = url
  }

  return {
    newWindow,
    openWindow,
  }
}
